import React from 'react';
import { Icon } from '@digitools/honest-react';
import useReportDownload from './useReportDownload';
import useTealium from 'src/hooks/useTealium';
import { TEALIUM_EVENT } from 'src/constants/tealiumConstants';

const DownloadNoteReportCell =
  noteBasicDetails =>
  ({ data }) => {
    const { trackEvent } = useTealium();
    const { sendRequest } = useReportDownload();
    const onDownloadReport = () => {
      const payload = { ...noteBasicDetails, notesResourceList: [data._original] };
      const url = `/status-service/report/notes/download`;
      sendRequest(url, payload);
      trackEvent({
        event_action: TEALIUM_EVENT.EVENT_ACTION.DOWNLOAD,
        event_type: TEALIUM_EVENT.EVENT_TYPE.VIEW_STATUS,
        event_name: `download - ${data._original.noteType} notes`,
        event_version: `${data._original.noteType} details`,
      });
    };
    return (
      <a onClick={onDownloadReport} aria-label='Download note'>
        <Icon name='download' alt={'Download Note'} color={'secondary'} />
      </a>
    );
  };
export default DownloadNoteReportCell;
